import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageUploadTiles } from '../-components/PageUploadTiles'
import { useCoreUploadTiles } from '../-hooks/useCoreUploadTiles'
import { ON_HAND_INVENTORY_UPLOAD_TYPES } from './-upload-types'

export const Route = createFileRoute('/_auth/_modules/_app/core-upload-data/on-hand-inventory/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation('uploads')
  const tiles = useCoreUploadTiles(ON_HAND_INVENTORY_UPLOAD_TYPES)

  return (
    <PageUploadTiles
      tiles={tiles}
      header={t('uploadData.onHandInventory.title')}
      description={t('uploadData.onHandInventory.description')}
    />
  )
}
